import { usePrevious } from "@finbackoffice/site-core";
import { useDevice } from "hooks/base";
import { RefObject, useEffect } from "react";
import { scrollWithOffset } from "utils/helpers";

type IUseScrollToSelectedGameProps = {
    selectedGameId: number | null;
    gameRef: RefObject<any>;
    gameId: number;
    offset?: number;
    onScrollComplete?: () => void;
};

export const useScrollToSelectedGame = ({
    selectedGameId,
    gameId,
    gameRef,
    offset,
    onScrollComplete,
}: IUseScrollToSelectedGameProps) => {
    const { isMobileDevice } = useDevice();
    const prevSelectedGameId = usePrevious(selectedGameId);

    useEffect(() => {
        const handleScroll = async () => {
            if (
                !isMobileDevice &&
                gameRef.current &&
                !prevSelectedGameId &&
                gameId === selectedGameId
            ) {
                await scrollWithOffset(
                    gameRef.current,
                    offset && offset > 0 ? offset : undefined,
                    true,
                );
                onScrollComplete?.();
            }
        };

        void handleScroll();
    }, [
        selectedGameId,
        prevSelectedGameId,
        gameRef,
        gameId,
        offset,
        onScrollComplete,
        isMobileDevice,
    ]);
};
